export default "__VITE_ASSET__BOcay1Vw__"